var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.animated ? 'animate' : '',style:([
    _vm.icon !== ''
      ? {
          color: _vm.color,
          border: _vm.border,
          backgroundColor: _vm.bgcolor,
          fontSize: _vm.fontSize + 'px',
          height: _vm.height + 'px',
          width: _vm.width,
          margin: _vm.margin,
          padding: _vm.padding,
          verticalAlign: _vm.valign,
          backgroundImage: ("url(" + (require(("@/assets/icons/" + _vm.icon + ".svg"))) + ")"),
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: '100%',
          boxShadow: _vm.shadow ? '2px 2px 8px 0 rgba(0, 0, 0, 0.07)' : ''
        }
      : {
          color: _vm.disabled ? '#b5b5b5' : _vm.color,
          pointer: _vm.disabled ? 'not-allowed' : 'pointer',
          border: _vm.disabled ? 'solid  #b5b5b5' :_vm.border ,
          backgroundColor: _vm.disabled ? '#FFFFFF' : _vm.bgcolor,
          fontSize: _vm.fontSize + 'px',
          height: _vm.height + 'px',
          width: _vm.width,
          margin: _vm.margin,
          padding: _vm.padding,
          verticalAlign: _vm.valign,
          boxShadow: _vm.shadow ? '2px 2px 8px 0 rgba(0, 0, 0, 0.07)' : ''
        }
  ]),attrs:{"disabled":_vm.disabled,"title":_vm.buttonTitle},on:{"click":function($event){_vm.shouldAnimate ? (_vm.animated = true) : null},"animationend":function($event){_vm.animated = false}}},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }